import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TsButtonModule, TSIconModule } from 'tsui';

@Component({
  selector: 'app-tasks-empty',
  standalone: true,
  imports: [TSIconModule, TsButtonModule],
  template: `
    <div class="noop">
      <div class="noop__icons">
        <div class="noop__icons__row">
          <ts-icon icon="ts_chart-bar" size="medium" color="light-gray"></ts-icon>
          <ts-icon icon="ts_chart-line" size="medium" color="light-gray"></ts-icon>
        </div>
        <div class="noop__icons__row">
          <ts-icon icon="ts_chart-pie-alt" size="medium" color="light-gray"></ts-icon>
          <ts-icon icon="ts_robot" size="medium" color="orange"></ts-icon>
        </div>
      </div>
      <div class="noop__caption">
        <p class="noop__caption__title">Nothing to see here</p>
        @if (allowTaskListCreation) {
          <p class="noop__caption__subtitle">You can start by creating a task list</p>
          <ts-button (click)="createTaskList.emit()" size="small">Create task list</ts-button>
        }
      </div>
    </div>
  `,
  styleUrl: './tasks-empty.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TasksEmptyComponent {
  @Input() allowTaskListCreation = false;
  @Output() createTaskList: EventEmitter<void> = new EventEmitter<void>();
}
